import { ApolloError } from '@apollo/client';
import { ReturnCaddiesError, ReturnCaddyErrorCode } from '@bechtel/types';

export type ReturnCaddyErrorType = ReturnCaddyErrorCode | ApolloError;

export interface ReturnCaddyErrorProps {
  errors: ReturnCaddiesError[] | ApolloError;
  close: () => void;
}
